export default __webpack_public_path__ + "static/media/news-icon.5c93c832.png";